module.exports = __webpack_public_path__ + "static/media/ic_affaire_white.d3117bbb.svg";